"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRouterHashLink = require("react-router-hash-link");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * A basic link component, that can be used as an internal router link or an eternal anchor
 * @param {string}    to        The URL / Path to navigate to
 * @param {boolean}   external  Wether or not to open in a new window
 * @param {Children}  children  The react children
 * @param {noFollow}  SEO,    if noFollow===true then rel='nofollow'
 */
var Link = function Link(_ref) {
  var _ref$to = _ref.to,
      to = _ref$to === void 0 ? '' : _ref$to,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      children = _ref.children,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      _ref$anchor = _ref.anchor,
      anchor = _ref$anchor === void 0 ? false : _ref$anchor,
      _ref$noFollow = _ref.noFollow,
      noFollow = _ref$noFollow === void 0 ? false : _ref$noFollow,
      className = _ref.className,
      id = _ref.id,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  var relTag = 'follow';

  if (noFollow) {
    relTag = 'nofollow';
  }

  if (external) {
    relTag = relTag + ' noopener noreferrer';
  }

  if (anchor) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterHashLink.HashLink, {
      rel: relTag,
      className: className,
      to: to,
      title: title,
      onClick: onClick,
      children: children
    });
  }

  return to && (to.startsWith('http') || to.startsWith('//')) || external ?
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-target-blank
  (0, _jsxRuntime.jsx)("a", {
    href: to,
    target: external ? '_blank' : '_self',
    rel: relTag,
    className: className,
    id: id,
    title: title,
    onClick: onClick,
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
    rel: relTag,
    className: className,
    title: title,
    to: to,
    id: id,
    onClick: onClick,
    children: children
  });
};

var _default = Link;
exports.default = _default;